import React from 'react'
import PropTypes from 'prop-types'

import { Notification } from '../../Notification/Notification'
import { useFulfillment } from '../../FulfillmentProvider/DeliveryFulfillmentProvider'
import { useAvailability } from '../../../utils/availability'
import { FULFILLMENT_TYPES } from '../../FulfillmentProvider/initial-fulfillment-state'

const { ASAP } = FULFILLMENT_TYPES

export const FulfillmentNotification = ({ cartHasItems, diningOptionBehavior }) => {
  const { valid, selected } = useFulfillment()
  const { futureDatesAvailable, availability } = useAvailability()
  return (
    <React.Fragment>
      {!valid && (
        <Notification severity='warning'>
        Your order time is no longer available so your cart has been
        cleared. Select a new time to begin a new order.
        </Notification>
      )}
      {!availability[ASAP][diningOptionBehavior] && (
        <Notification>
        You can only place scheduled orders right now
        </Notification>
      )}
      {selected &&
      cartHasItems &&
      valid &&
      futureDatesAvailable && (
        <Notification>
          Changing your order time will remove all items you currently
          have in your cart
        </Notification>
      )}
    </React.Fragment>
  )
}

FulfillmentNotification.propTypes = {
  cartHasItems: PropTypes.bool,
  diningOptionBehavior: PropTypes.string
}
